//------------------------------------------------------------------------------
// BFA10104G 共架申込 通信設備 - 地図/ポップアップ
//------------------------------------------------------------------------------
import openPolePopup from './pole-open';
import openLinkPopup from './link-open';
import closePopup from './close-popup.js';
import { PolePopupContent, polePopupTitle } from './pole-content';
import { LinkPopupContent, linkPopupTitle } from './link-content';

// エクスポート
export default {

  // オープン
  openPolePopup,
  openLinkPopup,

  // クローズ
  closePopup,

  // タイトル
  polePopupTitle,
  linkPopupTitle,

  // ポップアップ内容
  PolePopupContent,
  LinkPopupContent,
};
